import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './TableBody.module.scss';
import cn from 'classnames';
const TableBody = ({ columns, tableData, className, columnEnd, columnStart, onClick }) => {
    const setData = (data) => {
        if (onClick) {
            onClick(data);
        }
    };
    return (_jsx("div", { children: tableData.map((data, index) => {
            return (_jsxs("div", Object.assign({ className: cn(styles.wrapper, className, columnEnd && styles['isColumnEnd']) }, { children: [columnStart && (_jsx("div", Object.assign({ "data-testid": "table", onClick: () => setData(data) }, { children: typeof columnStart === 'function'
                            ? columnStart(data)
                            : columnStart }))), columns.map(({ accessor }) => {
                        const tData = data[accessor] ? data[accessor] : '—';
                        return accessor !== 'name' ? (_jsx("div", Object.assign({ className: cn(styles.column, 'd-flex align-items-center') }, { children: tData }), accessor)) : (_jsx("div", Object.assign({ className: cn(styles.column, 'd-flex align-items-center'), onClick: () => setData(data) }, { children: tData }), accessor));
                    }), typeof columnEnd === 'function' ? columnEnd(data) : columnEnd] }), index));
        }) }));
};
export default TableBody;
